'use strict';

/* Story Properties that will be shared in the storyApp */

angular.module('storyApp').factory('storyProperties', function() {

    var doc = document;

    var pros = {

        skinAdElm: document.getElementById("skinContainer"),

        centerBlock: document.getElementById("center-block"),

        navWrapper: document.getElementById("js-body-header"),

        secNav: document.querySelector(".section-nav"),

        navHeight: 84,

        belowNavAd: document.querySelector(".adplaceholderBelowNavigation"),

        mainThumb: document.querySelector("#sidebar .main-thumbnail"),

        mainStory: document.getElementById("story-1"),

        sideBar: document.getElementById("sidebar"),

        scorestrip: document.getElementById("wisss"),

        headerWrapper: document.getElementById("header-wrapper"),

        bannerAdContainer: document.querySelector(".banner-ad-container"),

        bodyClassList: document.body.classList,

        socialBarBtmOffset: 503,

        socialBarTopOffset: 135,

        skinAdPinTopPos: 40,

        skinAdUnPinOffset: 0,

        rightRailAdPinOffset: 50,

        totalHeaderHeight: 0,

        totalHeight: 0,

        secNavHeight: 0,

        getViewPort: function() {

            var winW = window.innerWidth;

            var chkViewPort = (winW < 768) ? 'mobile' : ((winW > 1023) ? 'desktop' : 'tablet ');

            return chkViewPort;

        },
        getPromoHeight: function() {
            if (this.bodyClassList.contains('branch-banner-is-active')) {
                return 76;
            }
            return 0;
        },

        init: function() {

            if (!this.secNav) {
                this.socialBarBtmOffset = 428;
                this.socialBarTopOffset = 60;
                this.skinAdPinTopPos = 0;
                this.skinAdUnPinOffset = -130;
                this.rightRailAdPinOffset = 10;
                this.secNavHeight = 0;

            } else {
                this.secNavHeight = this.secNav.offsetHeight;
            }
        }

    };

    pros.init();
    
    return pros;

});


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/storyProperties.js